import React from 'react';
import { Section } from './Section';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <Section data-id="element-114">
      <div className="max-w-4xl mx-auto bg-accent/5 border border-accent/20 p-8 md:p-12 relative" data-id="element-115">
        <Quote className="absolute top-6 left-6 w-12 h-12 text-accent/20" data-id="element-116" />
        <p className="text-xl md:text-3xl text-white font-medium leading-relaxed text-center relative z-10 italic" data-id="element-117">
          "En los primeros 7 días de usar la Maquinaria de Enfoque, la mayoría
          de los usuarios reportan haber terminado proyectos que llevaban meses
          estancados, recuperando un promedio de{' '}
          <span className="text-accent font-bold not-italic" data-id="element-118">
            15 a 20 horas libres a la semana
          </span>
          ."
        </p>
      </div>
    </Section>;
}